import httpClient, { httpClientWithoutLoading } from '../index.js';

const END_POINT = 'HighRiseServices/GetSearchedModel';

const modelsSaleFish = () => httpClientWithoutLoading.get(`sale-fish/model-units`);
// const modelsSaleFish = data => httpClientSaleFish.post(`${END_POINT}`, { ...data });

// sale-fish/model-units
export { modelsSaleFish };
